import { render, staticRenderFns } from "./TeachingUserPaperLogList.vue?vue&type=template&id=6180b7c0&scoped=true"
import script from "./TeachingUserPaperLogList.vue?vue&type=script&lang=js"
export * from "./TeachingUserPaperLogList.vue?vue&type=script&lang=js"
import style0 from "./TeachingUserPaperLogList.vue?vue&type=style&index=0&id=6180b7c0&prod&scoped=true&lang=css"
import style1 from "./TeachingUserPaperLogList.vue?vue&type=style&index=1&id=6180b7c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180b7c0",
  null
  
)

export default component.exports